import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./noPreview.css";
import { useIntl } from "react-intl";

const NoPreview = ({height}) => {
  const intl = useIntl();
  return (
    <div className='noPreview-container' style={height ? { height: height} : {}}>
      <div className='noPreview-icon'><FontAwesomeIcon icon={["far", "file-times"]} /></div>
      <div className='noPreview-title'>{intl.formatMessage({id: "documents.noPreview", defaultMessage: "Non è possibile visualizzare l'anteprima di questo documento"})}</div>
      <div className='noPreview-description'>{intl.formatMessage({id: "documents.noPreviewDesc", defaultMessage: "Per vedere il contenuto è necessario effettuare il download del file e aprirlo"})}</div>
    </div>
  );
};

export default NoPreview;